import { newFieldId } from '../../shared/fieldIds';
import { makeField } from '../../shared/fieldTypes';

// The "<Brand> account info" toggle (build plan §5.5): five fields that
// pre-fill from the racer's profile, marked `acct: true` so turning the
// toggle off removes exactly them.

export const ACCOUNT_INFO_SET = [
  { type: 'name', label: 'Name', map: 'full_name' },
  { type: 'address', label: 'Address', map: 'address' },
  {
    type: 'datetime',
    label: 'Date of Birth',
    map: 'date_of_birth',
    required: true,
  },
  { type: 'phone', label: 'Phone Number', map: 'cellphone' },
  { type: 'email', label: 'Email Address', map: 'email' },
];

// What the palette card lists (design: stacked, one per row).
export const ACCOUNT_INFO_ROWS = [
  { icon: 'user', label: 'Name' },
  { icon: 'map-pin', label: 'Address' },
  { icon: 'calendar', label: 'Date of birth' },
  { icon: 'phone', label: 'Phone number' },
  { icon: 'mail', label: 'Email' },
];

// Leading content blocks the set goes after (a logo, an intro text…).
const LEADING = ['description', 'image', 'video'];

export const hasAccountInfo = (fields) => fields.some((f) => f.acct);

// The five fields, with the given ids (minted by the caller so the reducer
// stays pure).
export const accountInfoFields = (ids = []) =>
  ACCOUNT_INFO_SET.map((spec, i) => {
    const base = makeField(spec.type, ids[i] || newFieldId());
    return {
      ...base,
      label: spec.label,
      required: spec.required === undefined ? base.required : spec.required,
      map: spec.map,
      acct: true,
    };
  });

export const addAccountInfo = (fields, ids) => {
  if (hasAccountInfo(fields)) return fields;
  const lead = fields.findIndex((f) => !LEADING.includes(f.type));
  const at = lead < 0 ? fields.length : lead;
  return [
    ...fields.slice(0, at),
    ...accountInfoFields(ids),
    ...fields.slice(at),
  ];
};

export const removeAccountInfo = (fields) =>
  hasAccountInfo(fields) ? fields.filter((f) => !f.acct) : fields;

export const accountInfoIds = () => ACCOUNT_INFO_SET.map(() => newFieldId());
